import axios from "axios";
import router from "@/router";

export const apiClient = axios.create({
    baseURL: "/api/v0",
});

apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        const isAuthRequest =
            axios.isAxiosError(error) && (error.config?.url?.startsWith("/auth/") ?? false);
        if (
            axios.isAxiosError(error) &&
            error.response?.status === 401 &&
            !isAuthRequest &&
            router.currentRoute.value.name !== "Login"
        ) {
            void router.push({
                name: "Login",
                query: { redirect: router.currentRoute.value.fullPath },
            });
        }
        return Promise.reject(error instanceof Error ? error : new Error(String(error)));
    }
);
